export default __webpack_public_path__ + "static/media/IMG_20210905_145926_439.3bf27152.jpg";